import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import "@/assets/css/slider.css"

const PrevArrowBtn = ({ onClickBtn }) => {
  const handleClickBtn = () => {
    onClickBtn()
  }

  return (
    <button className="slick-prev--custom max-xs:text-base text-xl sm:text-2xl lg:text-3xl max-xs:left-1 left-2 sm:left-4 lg:left-8" onClick={handleClickBtn}><FontAwesomeIcon icon={faChevronLeft} /></button>
  )
}

const NextArrowBtn = ({ onClickBtn }) => {
  const handleClickBtn = () => {
    onClickBtn()
  }

  return (
    <button className="slick-next--custom max-xs:text-base text-xl sm:text-2xl lg:text-3xl max-xs:right-1 right-2 sm:right-4 lg:right-8" onClick={handleClickBtn}><FontAwesomeIcon icon={faChevronRight} /></button>)
}
const LargerPrevArrowBtn = ({ onClickBtn }) => {
  const handleClickBtn = () => {
    onClickBtn()
  }

  return (
    <button className="slick-prev--custom text-[5rem]" onClick={handleClickBtn}><FontAwesomeIcon icon={faChevronLeft} size="xs" /></button>
  )
}

const LargerNextArrowBtn = ({ onClickBtn }) => {
  const handleClickBtn = () => {
    onClickBtn()
  }

  return (
    <button className="slick-next--custom text-[5rem]" onClick={handleClickBtn}><FontAwesomeIcon icon={faChevronRight} size="xs" /></button>)
}

export {
  PrevArrowBtn,
  NextArrowBtn,
  LargerPrevArrowBtn,
  LargerNextArrowBtn
}